/* src/app/shared-module/components/invitations/invitations.component.scss */
.inv-card {
  margin: 10px 10px 16px;
  border-radius: 22px;
  border: 1px solid var(--ion-color-light-tint);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background: var(--ion-color-secondary);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.inv-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.13);
}
.inv-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px 10px;
  border-bottom: 1px solid var(--ion-color-light-tint);
  background:
    linear-gradient(
      135deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
}
.inv-header-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 12px;
  background: var(--ion-color-secondary-shade);
  color: white;
  border: 1.2px solid var(--ion-color-secondary-shade);
}
.inv-header-icon-box ion-icon {
  font-size: 20px;
}
.inv-header-content {
  flex: 1;
  min-width: 0;
}
.inv-kicker {
  display: block;
  font-size: 10px;
  letter-spacing: 1px;
  font-weight: 500;
  text-transform: uppercase;
  color: var(--ion-color-secondary-shade);
}
.inv-title {
  margin: 2px 0 0;
  font-size: 15px;
  color: var(--ion-color-secondary-shade);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.inv-responded-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 20px;
  flex-shrink: 0;
}
.inv-responded-badge ion-icon {
  font-size: 13px;
}
.inv-body {
  padding: 14px 16px 10px !important;
  -webkit-padding-start: 16px !important;
  padding-inline-start: 16px !important;
  -webkit-padding-end: 16px !important;
  padding-inline-end: 16px !important;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.inv-meta-row {
  display: flex;
  gap: 10px;
}
.inv-meta-item {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  background: white;
  color: var(--ion-color-secondary-shade);
  border: 1.5px solid var(--ion-color-secondary-shade);
}
.inv-meta-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  border-radius: 10px;
  flex-shrink: 0;
}
.inv-meta-icon-wrap ion-icon {
  font-size: 18px;
}
.inv-meta-icon-date {
  background: rgba(var(--ion-color-primary-rgb), 0.12);
  color: var(--ion-color-secondary-shade);
}
.inv-meta-icon-time {
  background: rgba(var(--ion-color-primary-rgb), 0.12);
  color: var(--ion-color-secondary-shade);
}
.inv-detail-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  background: white;
  color: var(--ion-color-secondary-shade);
  border: 1.5px solid var(--ion-color-secondary-shade);
}
.inv-detail-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  border-radius: 10px;
  flex-shrink: 0;
}
.inv-detail-icon-wrap ion-icon {
  font-size: 18px;
}
.inv-detail-icon-venue {
  background: rgba(var(--ion-color-primary-rgb), 0.12);
  color: var(--ion-color-secondary-shade);
}
.inv-detail-icon-info {
  background: rgba(var(--ion-color-primary-rgb), 0.12);
  color: var(--ion-color-secondary-shade);
}
.inv-detail-text {
  flex: 1;
  min-width: 0;
}
.inv-meta-label {
  display: block;
  font-size: 10px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--ion-color-medium);
  margin-bottom: 2px;
}
.inv-meta-value {
  display: block;
  font-size: 13px;
  color: var(--ion-color-secondary-shade);
  line-height: 1.4;
}
.inv-details-text {
  font-weight: 400;
  font-size: 12.5px;
  color: var(--ion-color-dark-tint);
}
.inv-rsvp-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid var(--ion-color-light-tint);
  background:
    linear-gradient(
      90deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
}
.inv-rsvp-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-shade);
  flex-shrink: 0;
}
.inv-rsvp-label ion-icon {
  font-size: 15px;
}
.inv-rsvp-actions {
  display: flex;
  gap: 8px;
}
.inv-rsvp-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px;
  border: none;
  border-radius: 50px;
  font-size: 12px;
  cursor: pointer;
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    opacity 0.18s ease;
}
.inv-rsvp-btn ion-icon {
  font-size: 16px;
}
.inv-rsvp-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}
.inv-rsvp-btn:active {
  transform: scale(0.96);
  opacity: 0.88;
}
.inv-rsvp-btn span {
  white-space: nowrap;
}
.inv-rsvp-accept {
  background: var(--ion-color-secondary-shade);
  color: white;
}
.inv-rsvp-maybe {
  background: var(--ion-color-secondary-shade);
  color: white;
}
.inv-rsvp-decline {
  background: var(--ion-color-primary);
  color: white;
}
@media (max-width: 360px) {
  .inv-rsvp-strip {
    flex-direction: column;
    align-items: flex-start;
  }
  .inv-rsvp-actions {
    width: 100%;
    justify-content: space-between;
  }
  .inv-rsvp-btn span {
    display: none;
  }
  .inv-rsvp-btn {
    padding: 8px 10px;
  }
}
/*# sourceMappingURL=invitations.component.css.map */
